<script>
import { Line } from "vue-chartjs";
import { X_POINT, emptyLabels, partografYAxis, partografXAxes, partografLayout } from "./partografAxis";

const WASPADA_MULAI = 0;
const WASPADA_SELESAI = 12;
const BERTINDAK_MULAI = 8;
const BERTINDAK_SELESAI = 20;

function garisReferensi(mulai, selesai) {
  const data = [];
  for (let i = 0; i <= X_POINT; i++) {
    if (i === mulai) data.push(4);
    else if (i === selesai) data.push(10);
    else data.push(NaN);
  }
  return data;
}

export default {
  extends: Line,
  props: {
    dataSet: {
      type: Object,
      default: function () {
        return { serviks: [], kepala: [], jam: [] };
      },
    },
  },
  data() {
    return {
      labels: emptyLabels(),
      chartData: null,
      options: {
        scales: {
          yAxes: [
            partografYAxis({
              suggestedMin: 0,
              suggestedMax: 10,
              stepSize: 1,
              beginAtZero: true,
            }),
          ],
          xAxes: partografXAxes(),
        },
        layout: partografLayout(),
        legend: { display: true, position: "bottom" },
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  methods: {
    computeLabels() {
      const src = (this.dataSet && this.dataSet.jam) || [];
      const out = [];
      for (let i = 0; i <= X_POINT; i++) {
        if (i % 2 !== 0) {
          out.push("");
          continue;
        }
        out.push(src.length ? src[i] || "" : String(Math.floor(i / 2)));
      }
      return out;
    },
    buildChartData() {
      return {
        labels: this.labels,
        datasets: [
          {
            label: "Pembukaan Serviks (X)",
            data: this.dataSet.serviks,
            pointStyle: "crossRot",
            pointRadius: 8,
            borderWidth: 2,
            spanGaps: true,
            tension: 0,
            fill: false,
            borderColor: "purple",
            backgroundColor: "purple",
          },
          {
            label: "GARIS BERTINDAK (Action Line)",
            data: garisReferensi(BERTINDAK_MULAI, BERTINDAK_SELESAI),
            spanGaps: true,
            fill: false,
            borderColor: "red",
            backgroundColor: "red",
            borderWidth: 2,
            pointRadius: 0,
          },
          {
            label: "GARIS WASPADA (Alert Line)",
            data: garisReferensi(WASPADA_MULAI, WASPADA_SELESAI),
            spanGaps: true,
            fill: false,
            borderColor: "orange",
            backgroundColor: "orange",
            borderWidth: 2,
            borderDash: [6, 4],
            pointRadius: 0,
          },
          {
            label: "Penurunan Kepala (O)",
            data: this.dataSet.kepala,
            pointStyle: "circle",
            pointRadius: 8,
            borderWidth: 2,
            spanGaps: true,
            cubicInterpolationMode: "monotone",
            tension: 0,
            fill: false,
            borderColor: "#2554FF",
            borderDash: [3, 3],
          },
        ],
      };
    },
    checkPartusMacet() {
      if (!this.dataSet || !this.dataSet.serviks) return;
      for (let i = 0; i < this.dataSet.serviks.length; i++) {
        const s = this.dataSet.serviks[i];
        if (s == null || s === "") continue;
        const expectedAtBertindakLine =
          i >= BERTINDAK_MULAI ? Math.min(10, 4 + (i - BERTINDAK_MULAI) * 0.5) : null;
        if (expectedAtBertindakLine !== null && Number(s) < expectedAtBertindakLine - 0.5) {
          this.$emit("alert-partus-macet", { index: i, serviks: s });
          return;
        }
      }
    },
    redraw() {
      this.labels = this.computeLabels();
      this.chartData = this.buildChartData();
      this.renderChart(this.chartData, this.options);
      this.checkPartusMacet();
    },
  },
  mounted() {
    this.redraw();
  },
  watch: {
    dataSet: function () {
      this.redraw();
    },
  },
};
</script>
